<template>
  <div id="app">

    <div :class="[isMobile ? 'top-layout-mobile' : 'top-layout']">
      <img class="logo" src="@/assets/home_logo.png">
      <img class="right-icon" src="@/assets/home_menu.png" v-if="isMobile" @click="drawer = true">
    </div>

    <div class="menu-layout" v-if="!isMobile">
      <el-menu :default-active="this.$route.path" router class="el-menu-demo" mode="horizontal" background-color="#D9C8AD"
        text-color="#301E03" active-text-color="#A05200">
        <el-menu-item :index="item.path" :route="item.path" v-for="(item, index)  in menuItems" :key="index" @click="resetClick">{{
            item.title
        }}
        </el-menu-item>
      </el-menu>
    </div>


    <div style="min-height: calc(60vh);">
      <router-view :netConfig="netConfig" />
    </div>



    <!--  底部  -->
    <div :class="[isMobile ? 'footer-layout-mobile' : 'footer-layout']">
      <div :class="[isMobile ? 'bottom-layout-mobile' : 'bottom-layout']">
        <img :class="[isMobile ? 'bottom-logo-mobile' : 'bottom-logo']" src="@/assets/bottom_logo.png">

        <div :class="[isMobile ? 'bottom-contact-mobile' : 'bottom-contact']">
          <label class="bottom-text_16">聯絡我們</label>
          <label :class="[isMobile ? 'bottom-text-mobile' : 'bottom-text']">社團網址：{{ netConfig['site_url'] }}</label>
          <label :class="[isMobile ? 'bottom-text-mobile' : 'bottom-text']">聯絡電話：{{ netConfig['site_phone'] }}</label>
        </div>



        <div :class="[isMobile ? 'bottom-contact-mobile' : 'bottom-contact_right']">
          <label class="bottom-text_16">關注我們</label>
          <img :class="[isMobile ? 'bottom-qrcode-mobile' : 'bottom-qrcode']" src="@/assets/qr_code.png">
          <label :class="[isMobile ? 'bottom-text-mobile' : 'bottom-text']">微信公眾號</label>
        </div>

      </div>

      <div class="bottom-line"></div>
      <label :class="[isMobile ? 'bottom-text1-mobile' : 'bottom-text1']" style="margin-top:16px"></label>
      <label :class="[isMobile ? 'bottom-text1-mobile_10' : 'bottom-text1']" >Copyright
        {{ netConfig['site_copyright'] }}</label>
      <label :class="[isMobile ? 'bottom-text1-mobile_10' : 'bottom-text1']">Powered by
        {{ netConfig['tech_support'] }}</label>
    </div>


    <!-- 侧面弹出的菜单 手机端用的 -->
    <el-drawer :visible.sync="drawer" :with-header="false" size="100%">
      <div class="drawer-bg">
        <img class="right-icon-mobile" src="@/assets/home_menu.png" v-if="isMobile" @click="drawer = false">
        <div class="drawer-menus">
          <label v-for="(item, index)  in menuItems" :key="index" class="drawer-item"
            :style="{ color: (index == activeIndexMobile - 1 ? '#A05200' : '#301E03') }"
            @click=toMenu(item.path,index)>{{item.title}}</label>
        </div>

      </div>
    </el-drawer>

  </div>


</template>


<script>
// import NetConfig from './constant';
export default {
  name: 'App',
  data() {
    return {
      // activeIndex: "/",
      activeIndexMobile: "1",
      netConfig: window.netConfig || {},
      isMobile: false,
      drawer: false,
      menuItems: [{ title: '首頁', path: "/" },
      { title: '最新消息', path: "/news" },
      { title: '關於總會', path: "/about" },
      { title: '會務動態', path: "/activity" },
      { title: '圖片集與視頻', path: "/media" },
      { title: '山東歷史文化知多D', path: "/knowledge" },
      { title: '魯澳經貿', path: "/trade" },
      { title: '聯絡我們', path: "/contact" }]
    }
  },
  created() {
    this.isMobile = this.isUserMobile()
    window.isMobile = this.isMobile
  },
  mounted() {
    let that = this
    this.$axios.get("index/config").then(function (response) {
      window.netConfig = {}
      if (response.data.code == 0) {
        response.data.data.forEach((item) => {
          that.$set(that.netConfig, item.code, item.value)
          window.netConfig[item.code] = item.value
        })
      }

    }, function (err) {
      console.log('errerrerrerrerr ' + err);
    });

    //監聽窗口大小
    // window.onresize=function(){
    //   that.isMobile = that.isUserMobile()
    //   window.isMobile = that.isMobile
    // };

    // this.activeIndex = this.getUrlParams();
    // console.log("this.activeIndex="+this.activeIndex)

    // console.log("this.$route.path="+this.$route.path)

  },
  methods: {
    // 獲取當前路徑
    // getUrlParams() {
    //   // window.location.href 获取地址
    //   let pathname = window.location.pathname
    //   return pathname
    // },

    isUserMobile() {
      const ua = navigator.userAgent.toLowerCase();
      return /mobile|android|iphone|ipod|phone|ipad/i.test(ua);
    },
    toMenu(path, index) {
      localStorage.setItem("curItem", 0);
      localStorage.setItem("curImagesId","");
      localStorage.setItem("curImagesTitle", "");

      console.log('click on item ' + path);
      this.$router.push(path)
      this.activeIndexMobile = index + 1
      this.drawer = false
    },

    resetClick(){
      localStorage.setItem("curItem", 0);
      localStorage.setItem("curImagesId","");
      localStorage.setItem("curImagesTitle", "");
    }
  }
}
</script>


<style lang="scss" scoped>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  display: flex;
  background-color: #EFE9E0;
  background-size: cover;
  flex-direction: column;
}



.top-layout {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 148px;

  .logo {
    width: 591px;
    height: 111px;
  }
}

.top-layout-mobile {
  background-color: #D9C8AD;
  position: relative;
  display: flex;
  padding-left: 14px;
  align-items: center;
  height: 80px;

  .logo {
    width: 274px;
    height: 53px;
  }

  .right-icon {
    position: absolute;
    right: 22px;
    width: 18px;
    height: 16px;
  }
}


.drawer-bg {
  background-color: #EFE9E0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: relative;

  .right-icon-mobile {
    position: absolute;
    right: 22px;
    top: 32px;
    width: 18px;
    height: 16px;
  }

  .drawer-menus {
    top: 80px;
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .drawer-item {
    width: 100%;
    margin-bottom: 32px;
    font-size: 18px;
    text-align: center;
  }
}



.menu-layout {
  width: 100%;
  background-color: #D9C8AD;
  height: 60px;
  display: flex;
  justify-content: center;
}


.footer-layout {
  box-sizing: border-box;
  width: 100%;
  height: 300px;
  background-color: #3E3426;
  display: flex;
  flex-direction: column;
  align-items: center;

  .bottom-layout {
    padding-left: 50px;
    padding-right: 50px;
    box-sizing: border-box;
    margin-top: 20px;
    width: 1140px;
    display: flex;
    align-items: top;
    justify-content: space-between;

    .bottom-contact {
      box-sizing: border-box;
      padding-left: 150px;
      display: flex;
      flex-direction: column;
    }

    .bottom-contact_right {
      box-sizing: border-box;
      margin-right: 100px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .bottom-text_16 {
        margin-top: 30px;
        margin-bottom: 6px;
        color: #DACEBD;
        font-size: 16px;
      }

      .bottom-text {
        text-align: center;
        color: #DACEBD;
        font-size: 14px;
        margin-top: 10px;
      }

      .bottom-qrcode {
        margin-top: 6px;
        width: 88px;
        height: 88px;
      }
    }
  }

  .bottom-logo {
    margin-top: 6px;
    width: 257px;
    height: 60px;
  }



  .bottom-text {
    display: block;
    color: #DACEBD;
    font-size: 14px;
    margin-top: 12px;
    font-family: 'Courier New', Courier, monospace;
  }

  .bottom-text_16 {
    margin-top: 30px;
    margin-bottom: 6px;
    color: #DACEBD;
    font-size: 16px;
  }


  .bottom-line {
    margin-top: 24px;
    width: 1140px;
    height: 1px;
    background-color: #D9CAB2;
    opacity: 0.1;
  }

  .bottom-text1 {
    color: #9C9386;
    font-size: 12px;
  }
}


.footer-layout-mobile {
  box-sizing: border-box;
  width: 100%;
  height: 469px;
  background-color: #3E3426;
  display: flex;
  flex-direction: column;
  align-items: center;

  .bottom-layout-mobile {
    box-sizing: border-box;
    padding-left: 28px;
    margin-top: 30px;
    width: 100%;
    display: flex;
    flex-direction: column;


    .bottom-contact-mobile{
      margin-top: 34px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;

      .bottom-qrcode-mobile {
        margin-top: 8px;
        width: 88px;
        height: 88px;
      }
    }


  }

  

  .bottom-logo-mobile {
    width: 192px;
    height: 42px;
  }

  .bottom-text-mobile {
    margin-top: 8px;
    color: #DACEBD;
    font-size: 12px;
    font-family: 'Courier New', Courier, monospace;
  }

  .bottom-text_16 {
    margin-bottom: 8px;
    color: #DACEBD;
    font-size: 16px;
  }

  .bottom-text1-mobile {
    margin-top: 4px;
    color: #DACEBD;
    font-size: 12px;
  }

  .bottom-text1-mobile_10 {
    margin-top: 4px;
    color: #9C9386;
    font-size: 10px;
  }

  .bottom-line {
    margin-top: 24px;
    width: 360px;
    height: 1px;
    background-color: #D9CAB2;
    opacity: 0.1;
  }
}
</style>
